import {
    WAIT_INIT_MODEL,
    GET_MODEL_ORGANIZATION_DATA,
    GET_MODEL_GROUP_DATA,
    FILTER_MODEL_ORGANIZATION,
    FILTER_MODEL_GROUP,
    GET_MODEL_PARAMETER_DATA,
    GET_INHERITANCEPOSITION_DATA,
    SAVE_MODEL_ORG_GROUP_DETAIL_DATA,
    GET_MODEL_ORGANIZATION_SELECT_DATA,
    GET_MODEL_LATANDLNG_DATA,
    GET_MODEL_PORTAL_LIST,
    GET_MODEL_PORTAL_LIST_FAIL,
    GET_MODEL_PORTAL_LIST_SUCCESS,
    GET_MODEL_NETWOK_ZONE_LIST,
    GET_MODEL_NETWOK_ZONE_LIST_FAIL,
    GET_MODEL_NETWOK_ZONE_LIST_SUCCESS,

    // site
    GET_ORGANIZATION_DATA,
    GET_ORGANIZATION_DATA_SUCCESS,
    GET_ORGANIZATION_DATA_FAIL,

    GET_MODEL_ORGANIZATION_DETAIL,

    // group
    GET_MODEL_GROUP_LIST,
    GET_MODEL_GROUP_LIST_SUCCESS,

    GET_MODEL_GROUP_DETAIL,

    SAVE_ORG_GROUP_DATA,
    SAVE_ORG_GROUP_DATA_SUCCESS,
    SAVE_ORG_GROUP_DATA_FAIL,

    // account
    GET_MODEL_ACCOUNT_LIST,
    GET_MODEL_ACCOUNT_LIST_SUCCESS,
    DELETE_ORG_GROUP_DATA_SUCCESS,
    DELETE_ORG_GROUP_DATA,
    DELETE_ORG_GROUP_DATA_FAIL,

    // guard schedule
    GET_MODEL_DEVICE_LIST,
    GET_MODEL_DEVICE_LIST_SUCCESS,
    GET_MODEL_DEVICE_LIST_FAIL,
    LOAD_MODEL_PICKDATE,
    CLOSE_MODEL_PICKDATE,
    GET_MODEL_SSID_BY_GROUP_LIST,
    GET_MODEL_SSID_BY_GROUP_LIST_SUCCESS,
    GET_MODEL_SSID_BY_GROUP_LIST_FAIL, 
    LOAD_TIME_TABLE, 
    CLOSE_TIME_TABLE,

    // radio cluster group
    GET_RADIO_CLUSTER_GROUP_LIST,
    GET_RADIO_CLUSTER_GROUP_LIST_SUCCESS,
    GET_RADIO_CLUSTER_GROUP_LIST_FIAL,

} from "../actions/model/index";

const doAction = (state, action) => {
    switch (action.type) {
        case GET_MODEL_ORGANIZATION_DATA:
            return {
                ...state,
                status: GET_MODEL_ORGANIZATION_DATA,
                orgList: action.params.orgList,
            }        
        case SAVE_ORG_GROUP_DATA:
            return {
                ...state,
                status: SAVE_ORG_GROUP_DATA,
                loading: true
            }
        case SAVE_ORG_GROUP_DATA_SUCCESS:
            return {
                ...state,
                status: SAVE_ORG_GROUP_DATA_SUCCESS,
                loading: false
            }
        case SAVE_ORG_GROUP_DATA_FAIL:
            return {
                ...state,
                status: SAVE_ORG_GROUP_DATA_FAIL,
                loading: false,
                errMsg: action.params.errMsg
            }
        case GET_MODEL_GROUP_LIST:
            return {
                ...state,
                status: GET_MODEL_GROUP_LIST,
                groupListByOrg: null,
            }
        case GET_MODEL_GROUP_LIST_SUCCESS:
            return {
                ...state,
                status: GET_MODEL_GROUP_LIST_SUCCESS,
                groupListByOrg: action.params.groupList,
            }
        case GET_MODEL_GROUP_DATA:
            return {
                ...state,
                status: GET_MODEL_GROUP_DATA,
                groupList: action.params.groupList,
            }
        case GET_MODEL_GROUP_DETAIL:
            return {
                ...state,
                status: GET_MODEL_GROUP_DETAIL,
                modelGroupDetail: action.params.modelGroupDetail,
            }
        case GET_MODEL_ORGANIZATION_DETAIL:
            return {
                ...state,
                status: GET_MODEL_ORGANIZATION_DETAIL,
                modelOrgDetail: action.params.modelOrgDetail,
            }
        case GET_ORGANIZATION_DATA:
            return {
                ...state,
                status: GET_ORGANIZATION_DATA,
                modelOrgDetail: null,
                loading: true
            }
        case GET_ORGANIZATION_DATA_SUCCESS:
            return {
                ...state,
                status: GET_ORGANIZATION_DATA_SUCCESS,
                modelOrgDetail: action.params.modelOrgDetail,
                loading: false
            }
        case GET_ORGANIZATION_DATA_FAIL:
            return {
                ...state,
                status: GET_ORGANIZATION_DATA_FAIL,
                modelOrgDetail: null,
                loading: false
            }
        case FILTER_MODEL_ORGANIZATION:
            return {
                ...state,
                status: FILTER_MODEL_ORGANIZATION,
                orgId: action.params.orgId,
                orgValue: action.params.orgValue,
            }
        case FILTER_MODEL_GROUP:
            return {
                ...state,
                status: FILTER_MODEL_GROUP,
                groupId: action.params.groupId,
                groupValue: action.params.groupValue,
            }
        case GET_MODEL_PARAMETER_DATA:
            return {
                ...state,
                status: GET_MODEL_PARAMETER_DATA,
                orgColumnsConfig: action.params.orgColumnsConfig,
                groupColumnsConfig: action.params.groupColumnsConfig,
                templateColumnsConfig: action.params.templateColumnsConfig
            }
        case GET_INHERITANCEPOSITION_DATA:
            return {
                ...state,
                status: GET_INHERITANCEPOSITION_DATA,
                inheritancePosition: action.params.inheritancePosition
            }
        case WAIT_INIT_MODEL:
            return {
                ...state,
                errMsg: null,
                status: WAIT_INIT_MODEL,
                popLoading: false
            }
        case SAVE_MODEL_ORG_GROUP_DETAIL_DATA:
            return {
                ...state,
                status: SAVE_MODEL_ORG_GROUP_DETAIL_DATA,
                saveInfo: action.params.info,
                saveConfirm: action.params.confirm
            }
        case GET_MODEL_ORGANIZATION_SELECT_DATA:
            return {
                ...state,
                status: GET_MODEL_ORGANIZATION_SELECT_DATA,
                selectOptions: action.params.options
            }
        case GET_MODEL_LATANDLNG_DATA:
            return {
                ...state,
                status: GET_MODEL_LATANDLNG_DATA,
                modelLatAndLngData: action.params.modelLatAndLngData,
                initialCenter: {
                    lat: action.params.modelLatAndLngData.latitude,
                    lng: action.params.modelLatAndLngData.longitude
                }
            }
        case GET_MODEL_ACCOUNT_LIST:
            return {
                ...state,
                status: GET_MODEL_ACCOUNT_LIST,
                accountList: null,
            }
        case GET_MODEL_ACCOUNT_LIST_SUCCESS:
            return {
                ...state,
                status: GET_MODEL_ACCOUNT_LIST_SUCCESS,
                accountList: action.params.accountList,
            }
        case DELETE_ORG_GROUP_DATA:
            return {
                ...state,
                status: DELETE_ORG_GROUP_DATA,

            }
        case DELETE_ORG_GROUP_DATA_SUCCESS:
            return {
                ...state,
                status: DELETE_ORG_GROUP_DATA_SUCCESS,

            }
        case DELETE_ORG_GROUP_DATA_FAIL:
            return {
                ...state,
                errMsg: action.params.errMsg,
                status: DELETE_ORG_GROUP_DATA_FAIL,

            }
        case GET_MODEL_DEVICE_LIST:
            return {
                ...state,
                status: GET_MODEL_DEVICE_LIST,
                deviceList: null,
                loading: true
            }
        case GET_MODEL_DEVICE_LIST_SUCCESS:
            return {
                ...state,
                status: GET_MODEL_DEVICE_LIST_SUCCESS,
                deviceList: action.params.deviceList,
                loading: false
            }
        case GET_MODEL_DEVICE_LIST_FAIL:
            return {
                ...state,
                status: GET_MODEL_DEVICE_LIST_FAIL,
                deviceList: null,
                loading: false
            }
        case GET_MODEL_SSID_BY_GROUP_LIST:
            return {
                ...state,
                status: GET_MODEL_SSID_BY_GROUP_LIST,
                ssidListByGroups: null,
                loading: true
            }
        case GET_MODEL_SSID_BY_GROUP_LIST_SUCCESS:
            return {
                ...state,
                status: GET_MODEL_SSID_BY_GROUP_LIST_SUCCESS,
                ssidListByGroups: action.params.ssidList,
                loading: false
            }
        case GET_MODEL_SSID_BY_GROUP_LIST_FAIL:
            return {
                ...state,
                status: GET_MODEL_SSID_BY_GROUP_LIST_FAIL,
                ssidListByGroups: null,
                loading: false
            }
        case GET_MODEL_NETWOK_ZONE_LIST:
            return {
                ...state,
                status: GET_MODEL_NETWOK_ZONE_LIST,
                networkZoneList: null,
                loading: true
            }
        case GET_MODEL_NETWOK_ZONE_LIST_SUCCESS:
            return {
                ...state,
                status: GET_MODEL_NETWOK_ZONE_LIST_SUCCESS,
                networkZoneList: action.params.networkZoneList,
                loading: false
            }
        case GET_MODEL_NETWOK_ZONE_LIST_FAIL:
            return {
                ...state,
                status: GET_MODEL_NETWOK_ZONE_LIST_FAIL,
                networkZoneList: null,
                loading: false
            }
        case GET_MODEL_PORTAL_LIST:
            return {
                ...state,
                status: GET_MODEL_PORTAL_LIST,
                guestPortalList: null,
                loading: true
            }
        case GET_MODEL_PORTAL_LIST_SUCCESS:
            return {
                ...state,
                status: GET_MODEL_PORTAL_LIST_SUCCESS,
                guestPortalList: action.params.guestPortalList,
                loading: false
            }
        case GET_MODEL_PORTAL_LIST_FAIL:
            return {
                ...state,
                status: GET_MODEL_PORTAL_LIST_FAIL,
                guestPortalList: null,
                loading: false
            }
        case LOAD_MODEL_PICKDATE:
            return {
                ...state,
                status: LOAD_MODEL_PICKDATE,
                modelPickDate: action.params.modelPickDate
            }
        case CLOSE_MODEL_PICKDATE:
            return {
                ...state,
                status: CLOSE_MODEL_PICKDATE,
                modelPickDate: null,
            }
        case LOAD_TIME_TABLE:
            return {
                ...state,
                status: LOAD_TIME_TABLE,
                modelTimeTable: action.params.modelTimeTable
            }
        case CLOSE_TIME_TABLE:
            return {
                ...state,
                status: CLOSE_TIME_TABLE,
                modelTimeTable: null,
            }
        case GET_RADIO_CLUSTER_GROUP_LIST:
            return {
                ...state,
                status: GET_RADIO_CLUSTER_GROUP_LIST,
            }
        case GET_RADIO_CLUSTER_GROUP_LIST_SUCCESS:
            return {
                ...state,
                status: GET_RADIO_CLUSTER_GROUP_LIST_SUCCESS,
                radioClusterGroupListByOrg: action.params.radioClusterGroupListByOrg
            }
        case GET_RADIO_CLUSTER_GROUP_LIST_FIAL:
            return {
                ...state,
                status: GET_RADIO_CLUSTER_GROUP_LIST_FIAL,
            }
        default:
            return state;
    }
};

const modelReducers = (
    state = {
        status: WAIT_INIT_MODEL,
        orgList: null,
        groupList: null,
        // modelDetailData: null,
        modelGroupDetail: null,
        modelOrgDetail: null,
        modelPickDate: null,
        modelTimeTable: null,
        orgColumnsConfig: null,
        groupColumnsConfig: null,
        templateColumnsConfig: null,
        popLoading: false,
        templateDetail: null,
        organizationList: null,
        deviceList: null,
        ssidList: null,
        ssidListByGroups: null,
        groupListByOrg: null,
        radioClusterGroupListByOrg: null
    },
    action
) => {
    switch (action.type) {
        default:
            return doAction(state, action);
    }
};

export default modelReducers;